import gql from "graphql-tag";

export const GET_MAIL_ADDRESS = gql`
    query MailAddress($mailAddressId: ID!){
        mailAddress(mailAddressId: $mailAddressId) {
            mailAddressId
            userId
            parentType
            parentId
            mailAddressType
            fullAddress
            googleId
            address1
            address2
            city
            state
            postalCode
            country
            primary
            createdAt
            updatedAt
            deletedAt
        }
    }
`;

export const GET_MAIL_ADDRESSES = gql`
    query MailAddresses($searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        mailAddresses(searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            mailAddressId
            userId
            parentType
            parentId
            mailAddressType
            fullAddress
            googleId
            address1
            address2
            city
            state
            postalCode
            country
            primary
            createdAt
            updatedAt
            deletedAt
        }
    }
`;

export const GET_MAIL_ADDRESSES_OF_PARENT = gql`
    query MailAddressesOfParent($parentType: String!, $parentId: ID!, $searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        mailAddressesOfParent(parentType: $parentType, parentId: $parentId, searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            mailAddressId
            userId
            parentType
            parentId
            mailAddressType
            fullAddress
            googleId
            address1
            address2
            city
            state
            postalCode
            country
            primary
            createdAt
            updatedAt
            deletedAt
        }
    }
`;

export const CREATE_MAIL_ADDRESS = gql`
    mutation CreateMailAddress($newMailAddress: newMailAddress!) {
        createMailAddress(
            newMailAddress: $newMailAddress
        ) {
            returnCode
            message
            id
            name
        }
    }
`;

export const UPDATE_MAIL_ADDRESS = gql`
    mutation UpdateMailAddress($changedMailAddress: changedMailAddress!) {
        updateMailAddress(
            changedMailAddress: $changedMailAddress
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_MAIL_ADDRESS= gql`
    mutation DeleteMailAddress($deleteMailAddressId: ID!) {
        deleteMailAddress(
            deleteMailAddressId: $deleteMailAddressId
        ) {
            returnCode
            message
        }
    }
`;
